document.addEventListener('DOMContentLoaded', function () {
  // Get form and submit button
  const form = document.getElementById('ContactForm');
  const submitButton = form.querySelector('button[type="submit"]');

  if (!form || !submitButton) return;

  // Function to check if form is valid and update submit button
  function updateSubmitButton() {
    const requiredFields = form.querySelectorAll('[data-required]');
    const homeUseCheckbox = document.getElementById('ContactForm-home-use');
    const commercialUseCheckbox = document.getElementById('ContactForm-commercial-use');
    let isValid = true;

    // Check required fields
    requiredFields.forEach((field) => {
      const fieldId = field.id;
      const value = field.value.trim();

      if (!value) {
        isValid = false;
      } else if (fieldId === 'ContactForm-email') {
        isValid = validateEmail(value);
      }
    });

    // Check if at least one checkbox is selected
    if (homeUseCheckbox && commercialUseCheckbox) {
      const isCheckboxValid = homeUseCheckbox.checked || commercialUseCheckbox.checked;
      if (!isCheckboxValid) {
        isValid = false;
      }
      updateCheckboxValidation(isCheckboxValid);
    }

    submitButton.disabled = !isValid;
    submitButton.style.cursor = isValid ? 'pointer' : 'not-allowed';
  }

  // Function to update checkbox validation
  function updateCheckboxValidation(isValid) {
    const checkboxError = document.getElementById('checkbox-error');
    if (checkboxError) {
      checkboxError.style.display = isValid ? 'none' : 'block';
    }
  }

  // Email validation function
  function validateEmail(email) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }

  // Phone validation function (basic)
  function validatePhone(phone) {
    const phoneRegex = /^[0-9\-\s\(\)\+]{7,}$/;
    return phoneRegex.test(phone);
  }

  // Validation function
  function validateField(field, isValid = true, errorMessage = '') {
    const fieldType = field.type;
    const fieldId = field.id;

    // Remove existing validation classes
    field.classList.remove('field--error');

    // Remove existing error message
    const existingError = document.getElementById(fieldId + '-error');
    if (existingError) {
      existingError.remove();
    }

    // Apply validation result
    if (!isValid) {
      field.classList.add('field--error');

      // Add error message
      const errorDiv = document.createElement('div');
      errorDiv.className = 'contact__field-error';
      errorDiv.id = field.id + '-error';
      errorDiv.innerHTML = `
        <span class="visually-hidden">Error</span>
        <span class="form__message">
          <span class="svg-wrapper">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 0C3.13 0 0 3.13 0 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm3.5 9.5l-1.4 1.4L7 8.4 4.9 10.5l-1.4-1.4L5.6 7 3.5 4.9l1.4-1.4L7 5.6l2.1-2.1 1.4 1.4L8.4 7l2.1 2.1z" fill="currentColor"/>
            </svg>
          </span>
          ${errorMessage}
        </span>
      `;
      field.parentNode.appendChild(errorDiv);
    } else {
      field.classList.remove('field--error');
    }

    // Update submit button state
    updateSubmitButton();
  }

  // Add input event listeners for real-time validation
  const formFields = form.querySelectorAll('input[type="email"], input[type="tel"], input[type="text"], textarea');

  formFields.forEach((field) => {
    field.addEventListener('input', function () {
      updateSubmitButton();
    });

    // Add blur event listeners to form fields
    field.addEventListener('blur', function () {
      const value = this.value.trim();
      const fieldId = this.id;

      if (fieldId === 'ContactForm-email') {
        if (this.hasAttribute('data-required') && !value) {
          validateField(this, false, 'Email is required');
        } else if (value) {
          const isValid = validateEmail(value);
          validateField(this, isValid, isValid ? '' : 'Please enter a valid email address');
        }
      } else if (this.hasAttribute('data-required') && !value) {
        validateField(this, false, fieldId === 'ContactForm-name' ? 'Name is required' : 'This field is required');
      }
    });

    // Add focus event listeners to clear validation
    field.addEventListener('focus', function () {
      this.classList.remove('field--error');
      const errorElement = document.getElementById(this.id + '-error');
      if (errorElement) {
        errorElement.remove();
      }
    });
  });

  // Add event listeners for checkboxes
  const homeUseCheckbox = document.getElementById('ContactForm-home-use');
  const commercialUseCheckbox = document.getElementById('ContactForm-commercial-use');

  if (homeUseCheckbox && commercialUseCheckbox) {
    [homeUseCheckbox, commercialUseCheckbox].forEach((checkbox) => {
      checkbox.addEventListener('change', function () {
        updateSubmitButton();
      });
    });
  }

  // Set initial button state
  updateSubmitButton();

  // Handle form submission
  form.addEventListener('submit', function (e) {
    // Button is already disabled if form is invalid, so just let it submit
    // Additional validation can be added here if needed
  });
});
